/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
module.exports = {
  "sitecoreApiKey": "{6AE7ADFC-741D-43B5-BE48-C87A6F662CBF}",
  "sitecoreApiHost": "https://sg.osim.com",
  "jssAppName": "osim-web-shop",
  "defaultLanguage": "en",
  "graphQLEndpointPath": "/api/osim-web-shop",
  "buildTime": "Mon Jun 24 2024 20:49:37 GMT+0700 (Indochina Time)",
  "gitVersion": "10593d5a937ef176bf6fee696eacc2565e7a88ee",
  "graphQLEndpoint": "https://sg.osim.com/api/osim-web-shop?sc_apikey={6AE7ADFC-741D-43B5-BE48-C87A6F662CBF}"
};